import React from "react";
import { faClipboardListCheck, faBuilding, faFolder } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { makeFullFormattedAddressWithObject } from "../../../../../utils/functions";
import { Container } from "semantic-ui-react";
import usePublicInspection from "../../../hooks/inspections/public/usePublicInspection";

export default function InspectionRequestHeader({ id }: { id: string }) {
  const { data } = usePublicInspection({ id: id });

  const inspectionType = data?.data.attributes.title;

  const address = data?.data.attributes.address;
  const addressText = makeFullFormattedAddressWithObject(address);

  const permit = data?.data.attributes.permit;
  const permitTypeName = permit?.permitsType?.name ?? "";
  const permitFormalNumber = permit?.reservationNumber
    ? permit.reservationNumber
    : permit?.confirmationNumber?.match(/.{3}/g)?.join("-") ?? "";

  return (
    <Container text className='tw-p-0 tw-text-[#000000de]'>
      <div className='tw-mb-1'>
        <FontAwesomeIcon className='tw-mr-3 tw-text-[1.2rem]' icon={faClipboardListCheck} />
        {inspectionType}
      </div>
      <div className='tw-mb-1'>
        <FontAwesomeIcon icon={faFolder} className='tw-mr-2 tw-text-[1.2rem]' />
        {permitTypeName}
        <span className='tw-ml-1 tw-font-bold tw-italic'>{permitFormalNumber}</span>
      </div>
      <div className='tw-mb-1'>
        <FontAwesomeIcon className='tw-mr-3 tw-text-[1.2rem]' icon={faBuilding} />
        {addressText}
      </div>
    </Container>
  );
}
